/* Manu AI v25 (22/10/2026) — arrivée rapide sur la fiche Teeinblue.
 * - La variante de la couleur choisie est mise directement dans le lien « Continuer » (?variant=…) : plus de rechargement de la fiche
 *   à l'arrivée (assets/ai-studio-handoff.js colorVariant() trouve la bonne variante et ne fait rien).
 * - La fiche est préchargée (prefetch / speculation rules) dès que le vêtement ou la couleur change : le template Teeinblue arrive plus vite.
 * S'appuie sur section._ais enrichie par v9 → v24 (handoffUrl : v18). */
(function () {
  'use strict';

  var cache = {};   // handle → { p: produit JSON | null, wait: Promise }

  function norm(x) { return String(x || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase(); }
  function handleOf(url) { var m = /\/products\/([^\/?#]+)/.exec(url || ''); return m ? m[1] : ''; }
  function load(h) {
    if (!h || !window.fetch) return null;
    if (!cache[h]) {
      cache[h] = { p: null };
      cache[h].wait = fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { cache[h].p = p; return p; }).catch(function () { delete cache[h]; return null; });
    }
    return cache[h];
  }

  // Variante de la couleur voulue, mêmes autres options que la variante par défaut de la fiche
  function variantFor(p, color) {
    if (!p || !color) return null;
    var o = typeof color === 'object' ? color : { k: color };
    var want = [norm(o.k || o.key || o.value || o.id || o.name), norm(o.n || o.name || o.label || o.title)].filter(Boolean);
    var vs = p.variants || [], oi = -1;
    (p.options || []).forEach(function (op, i) { if (oi < 0 && /couleur|colou?r|farbe|colore/i.test(typeof op === 'string' ? op : op.name)) oi = i; });
    if (oi < 0) return null;
    var cur = vs.filter(function (v) { return v.available; })[0] || vs[0];
    if (!cur) return null;
    var ok = vs.filter(function (v) { return want.indexOf(norm(v.options[oi])) > -1; });
    if (!ok.length) return null;
    var same = function (v) { return v.options.every(function (x, i) { return i === oi || x === cur.options[i]; }); };
    return ok.filter(function (v) { return same(v) && v.available; })[0] || ok.filter(function (v) { return v.available; })[0] || ok.filter(same)[0] || ok[0];
  }

  function setParam(url, k, v) {
    try { var u = new URL(url, location.origin); u.searchParams.set(k, v); return u.pathname + u.search + u.hash; } catch (e) { return url; }
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v25) return;
    inst._v25 = true;

    var baseUrl = inst.handoffUrl, warmed = {};
    inst.handoffUrl = function () {
      var u = baseUrl.apply(this, arguments), s = this.s;
      if (!s || (s.path === 'design' && s.design) || !s.support) return u;
      var c = cache[handleOf(s.support.url)], v = c && c.p && variantFor(c.p, s.color);
      return v ? setParam(u, 'variant', v.id) : u;
    };

    // Pastilles : seulement les couleurs du produit retenu. Construites depuis ses propres couleurs (la palette de base peut ne pas les contenir, et v18 retombait alors sur toutes les couleurs du sport)
    var basePal = inst.palette;
    inst.palette = function () {
      var pal = basePal.apply(this, arguments), st = this.s;
      if (!st || !st.designOk) return pal;
      var sp = st.support || (this.curSupport && this.curSupport());
      if (!sp || !sp.colors || !sp.colors.length) return pal;
      var out = [], seen = {};
      sp.colors.forEach(function (c) {
        var k = String(c.n || '').trim().toLowerCase(); if (!k || seen[k]) return; seen[k] = 1;
        var m = pal.filter(function (x) { return x.k === k; })[0];
        out.push(m || { k: k, n: c.n, h: c.h || '#cccccc', on: [] });
      });
      return out.length ? out : pal;
    };

    // Précharge la fiche (HTML) : speculation rules si le navigateur sait, sinon <link rel=prefetch>
    var warmEl = null;
    function warm(url) {
      if (!url || warmed.last === url) return;
      warmed.last = url;
      try {
        if (warmEl && warmEl.parentNode) warmEl.parentNode.removeChild(warmEl);   // une seule préparation à la fois (pas une par couleur essayée)
        if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
          var sc = document.createElement('script'); sc.type = 'speculationrules';
          sc.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url], eagerness: 'immediate' }] });
          document.head.appendChild(sc); warmEl = sc;
        } else {
          var l = document.createElement('link'); l.rel = 'prefetch'; l.href = url; l.as = 'document'; document.head.appendChild(l); warmEl = l;
        }
      } catch (e) {}
    }

    function sync() {
      var s = inst.s; if (!s || !s.support || !s.support.url || s.path === 'design') return;
      var h = handleOf(s.support.url), c = load(h);
      if (!c) return;
      var go = function () { document.querySelectorAll('[data-ais] [data-act="handoff"]').forEach(function (a) { if (a.tagName === 'A') a.href = inst.handoffUrl(); }); };
      go();
      if (c.wait) c.wait.then(function () { go(); if (s.designOk || s.zonesOk || s.faces && (s.faces.front || s.faces.back)) warm(inst.handoffUrl()); });
    }

    // Changement de vêtement ou de couleur : on rafraîchit les liens et on préchauffe
    var lastKey = '';
    setInterval(function () {
      var s = inst.s, key = s && s.support ? (s.support.url || '') + '|' + (s.color && (s.color.k || s.color)) : '';
      if (key !== lastKey || (key && !cache[handleOf(s.support.url)])) { lastKey = key; sync(); }
    }, 700);

    // Dernier recours juste avant le clic : le lien porte la bonne variante
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-act="handoff"]');
      if (a) a.href = inst.handoffUrl();
    }, true);
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      if (root._ais && root._ais._v18) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
